export default "__VITE_ASSET__CDvd7c7a__"